import {createSelector} from '@ngrx/store';
import {selectAdm1nState} from '@store/app.states';

export const selectAdminOrganizationsState = createSelector(
  selectAdm1nState,
  (state) => state.organizationList
);
export const selectAdminOrganizations = createSelector(
  selectAdminOrganizationsState,
  (state) => state.list
);
